// Bridges a structured Job (jobs slice / fixtures) into the `appointment` prop
// shape expected by the existing JobCalendar AppointmentModal and JobSetupModal
// (both read appointment.job.report.{address,client,agent,...}). This keeps the
// modals untouched while they are opened from the new Job Detail page.

export const toAppointmentShape = (job) => {
  if (!job) return null;
  const address = job.address || {};
  return {
    id: job.appointment_id || null,
    start_time: job.start_time,
    end_time: job.end_time,
    date: job.date,
    tag: job.status,
    status: job.status,
    note: job.note || "",
    job: {
      id: job.id,
      note: job.job_setup?.note || "",
      quote: job.job_setup?.quote ?? null,
      template: job.job_setup?.template_id
        ? { id: job.job_setup.template_id, name: job.job_setup.template_name }
        : null,
      client_provided_agent_name: job.client_provided_agent_name || null,
      client_provided_agent_phone: job.client_provided_agent_phone || null,
      client_provided_agent_email: job.client_provided_agent_email || null,
      report: {
        id: job.report_id || null,
        item_count: job.inspection?.item_count || 0,
        address: {
          address_line1: address.line1 || "",
          address_line2: address.line2 || "",
          city: address.city || "",
          state: address.state || "",
          zip_code: address.zip || "",
        },
        year_build: job.property?.year_built || "",
        floor_area: job.property?.square_feet || "",
        stories: job.property?.stories || "",
        house_type: job.property?.house_type || "",
        apn: job.property?.parcel_number || "",
        info: job.property?.info || "",
        client: job.client || null,
        agent: job.agent || null,
        agent_applicable: job.agent_applicable ?? Boolean(job.agent),
      },
    },
  };
};
